import { createRouter, createWebHistory } from 'vue-router'
import Home from '../components/Home.vue'
import Projets from '../components/Projets.vue'
import Certifications from '../components/Certifications.vue'
import CV from '../components/CV.vue'
// Corriger le chemin d'importation pour ProjetGeltram
import ProjetGeltram from '../components/projets/ProjetGeltram.vue'
import ProjetPokePuller from '../components/projets/ProjetPokePuller.vue'
import ProjetPokePullerWeb from '@/components/projets/ProjetPokePullerWeb.vue'
import ProjetArbreDeVie from '@/components/projets/ProjetArbreDeVie.vue'
import ProjetGSB from '@/components/projets/ProjetGSB.vue'
import Grille from '@/components/Grille.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/projets',
        name: 'Projets',
        component: Projets
    },
    {
        path: '/certifications',
        name: 'Certifications',
        component: Certifications
    },
    {
        path: '/cv',
        name: 'CV',
        component: CV
    },
        {
        path: '/grille',
        name: 'Grille',
        component: Grille
    },
    {
        path: '/projet-geltram',
        name: 'ProjetGeltram',
        component: ProjetGeltram
    },
    {
        path: '/projet-pokepuller',
        name: 'ProjetPokePuller',
        component: ProjetPokePuller
    },
    {
        path: '/projet-pokepullerweb',
        name: 'ProjetPokerPullerWeb',
        component: ProjetPokePullerWeb
    },
    {
        path: '/stage-arbre-de-vie',
        name: 'ProjetArbreDeVie',
        component: ProjetArbreDeVie
    },
    {
        path: '/projet-gsb',
        name: 'ProjetGSB',
        component: ProjetGSB
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    // Ajoutez cette configuration pour le défilement
    scrollBehavior(to, from, savedPosition) {
        // Si l'utilisateur utilise les boutons précédent/suivant du navigateur
        // et qu'une position a été sauvegardée, on y retourne
        if (savedPosition) {
            return savedPosition
        } else {
            // Sinon, on remonte en haut de la page
            return { top: 0 }
        }
    }
})

export default router
